import { render } from "./PledgeManagerInfoHelpCenterLinksBox.vue?vue&type=template&id=2b687142"
import script from "./PledgeManagerInfoHelpCenterLinksBox.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoHelpCenterLinksBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__